export default __webpack_public_path__ + "static/media/DELETE.4d92b411.svg";